import { render } from "./ChatConnectionStatus.vue?vue&type=template&id=0b0b13f6&scoped=true"
const script = {}

import "./ChatConnectionStatus.vue?vue&type=style&index=0&id=0b0b13f6&scoped=true&lang=css"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0b13f6"]])

export default __exports__